import { concat } from 'lodash-es'
import SearchRoute from '../index'
import { suburbsToIds } from '../utils'

class AgentRoute extends SearchRoute {
  constructor() {
    super()
  }

  reset() {
    this.region = []
    this.district = []
    this.suburb = []
    this.surround = false
    this.order = null
    this.page = 1
    return this
  }

  toQuery(pageSize = 12) {
    const { region, district, suburb, page, ...args } = this
    const list = concat(region, district, suburb)
    const ids = suburbsToIds(list).idStr()

    return {
      limit: pageSize,
      offset: ((page || 1) - 1) * pageSize,
      ...ids,
      ...args
    }
  }
}

export default function getAgentRoute() {
  return new AgentRoute()
}